module.exports = __webpack_public_path__ + "img/Bertram.ef4cd12d.png";